var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue, isVariable } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../constants';
import { amountOutMinRisk } from './params';
import { BigNumber } from 'bignumber.js';
import { Uniswap } from '../helpers/Uniswap';
export var AddLiquidity = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'addLiquidity',
    description: 'Add liquidity on Uniswap',
    supportedContracts: ROUTER_V2_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    tokenA: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    tokenB: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                    amountADesired: new FctValue({ destination: 'wei_amount' }),
                    amountBDesired: new FctValue({ destination: 'wei_amount' }),
                    amountAMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    amountBMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
                liquidity: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            },
        });
    },
    initParams: {
        methodParams: {
            amountAMin: '0',
            amountBMin: '0',
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId, provider = _a.provider, account = _a.account;
        BigNumber.config({
            DECIMAL_PLACES: 0,
            ROUNDING_MODE: BigNumber.ROUND_FLOOR,
        });
        var helper = new Uniswap({ chainId: chainId, account: account, provider: provider });
        var prevAmountADesiredValue = isVariable(input.methodParams.amountADesired.value)
            ? input.methodParams.amountADesired.estimatedValue
            : input.methodParams.amountADesired.value;
        var prevAmountBDesiredValue = isVariable(input.methodParams.amountBDesired.value)
            ? input.methodParams.amountBDesired.estimatedValue
            : input.methodParams.amountBDesired.value;
        var getValues = function (_a) {
            var changedParamKey = _a.changedParamKey;
            return __awaiter(void 0, void 0, void 0, function () {
                var _b, tokenA, tokenB, amountADesired, amountBDesired, tokenAValue, tokenBValue, amountADesiredValue, amountBDesiredValue, rates, reserves, amountBValue, amountAValue;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = input.methodParams, tokenA = _b.tokenA, tokenB = _b.tokenB, amountADesired = _b.amountADesired, amountBDesired = _b.amountBDesired;
                            tokenAValue = tokenA.value;
                            tokenBValue = tokenB.value;
                            if (typeof tokenAValue !== 'string')
                                return [2 /*return*/, { params: {}, error: undefined }];
                            if (typeof tokenBValue !== 'string')
                                return [2 /*return*/, { params: {}, error: undefined }];
                            amountADesiredValue = isVariable(amountADesired.value)
                                ? amountADesired.estimatedValue
                                : amountADesired.value;
                            amountBDesiredValue = isVariable(amountBDesired.value)
                                ? amountBDesired.estimatedValue
                                : amountBDesired.value;
                            return [4 /*yield*/, helper.getToken1LiquidityRate({
                                    token0: tokenAValue,
                                    token1: tokenBValue,
                                })];
                        case 1:
                            rates = _c.sent();
                            if (!rates)
                                return [2 /*return*/, { params: {}, error: 'no rates' }];
                            return [4 /*yield*/, helper.getReserves({
                                    token0: tokenAValue,
                                    token1: tokenBValue,
                                })];
                        case 2:
                            reserves = _c.sent();
                            if (!reserves)
                                return [2 /*return*/, { params: {}, error: 'no reserves' }];
                            console.log({ rates: rates, reserves: reserves, amountADesiredValue: amountADesiredValue, prevAmountADesiredValue: prevAmountADesiredValue });
                            if (!isVariable(amountBDesired.value) &&
                                typeof amountADesiredValue === 'string' &&
                                prevAmountADesiredValue !== amountADesiredValue) {
                                prevAmountADesiredValue = amountADesiredValue;
                                amountBValue = new BigNumber(amountADesiredValue).multipliedBy(rates).toString();
                                prevAmountBDesiredValue = amountBValue;
                                console.log({ amountBValue: amountBValue, amountADesiredValue: amountADesiredValue });
                                if (changedParamKey !== 'methodParams.amountBDesired')
                                    amountBDesired.value = amountBValue;
                                return [2 /*return*/, {
                                        params: {
                                            methodParams: { amountBDesired: amountBValue },
                                        },
                                        error: undefined,
                                    }];
                            }
                            if (!isVariable(amountADesired.value) &&
                                typeof amountBDesiredValue === 'string' &&
                                prevAmountBDesiredValue !== amountBDesiredValue) {
                                prevAmountBDesiredValue = amountBDesiredValue;
                                amountAValue = new BigNumber(amountBDesiredValue).dividedBy(rates).toString();
                                prevAmountADesiredValue = amountAValue;
                                if (changedParamKey !== 'methodParams.amountADesired')
                                    amountADesired.value = amountAValue;
                                return [2 /*return*/, {
                                        params: {
                                            methodParams: { amountADesired: amountAValue },
                                        },
                                        error: undefined,
                                    }];
                            }
                            return [2 /*return*/, { params: {}, error: undefined }];
                    }
                });
            });
        };
        return {
            get: getValues,
            depParamKeys: [
                'methodParams.tokenA',
                'methodParams.tokenB',
                'methodParams.amountADesired',
                'methodParams.amountBDesired',
            ],
        };
    },
    requiredApprovals: function (params) { return [
        {
            to: params.methodParams.tokenA.value,
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value },
            method: 'approve',
            protocol: 'ERC20',
        },
        {
            to: params.methodParams.tokenB.value,
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value },
            method: 'approve',
            protocol: 'ERC20',
        },
    ]; },
    // async assetFlow(params, chainId, walletAddress, vaultAddress, provider, method) {
    //   const {
    //     to,
    //     methodParams: { tokenA, tokenB, amountADesired, amountBDesired, amountAMin, amountBMin },
    //   } = params
    //   if (
    //     !tokenA.value ||
    //     !tokenB.value ||
    //     !to.value ||
    //     !amountADesired.value ||
    //     !amountBDesired.value ||
    //     !amountAMin.value ||
    //     !amountBMin.value ||
    //     !vaultAddress
    //   )
    //     return []
    //   if (
    //     typeof amountADesired.value !== 'string' ||
    //     typeof amountBDesired.value !== 'string' ||
    //     typeof amountAMin.value !== 'string' ||
    //     typeof amountBMin.value !== 'string' ||
    //     typeof tokenA.value !== 'string' ||
    //     typeof tokenB.value !== 'string' ||
    //     typeof to.value !== 'string'
    //   )
    //     return []
    //   function calculateLPTokens(
    //     reserveA: number,
    //     reserveB: number,
    //     previousReserveA: number,
    //     previousReserveB: number
    //   ): number {
    //     return Math.sqrt(reserveA * reserveB) - Math.sqrt(previousReserveA * previousReserveB)
    //   }
    //   return [
    //     {
    //       address: vaultAddress,
    //       toSpend: [
    //         {
    //           token: tokenA.value,
    //           amount: amountADesired.value,
    //         },
    //         {
    //           token: tokenB.value,
    //           amount: amountBDesired.value,
    //         },
    //       ],
    //       toReceive: [],
    //     },
    //   ]
    // },
});
